export default {
  auditLogsPaginated: {
    docs: [],
    totalDocs: null,
    limit: 20,
    totalPages: null,
    page: 1,
    pagingCounter: null,
    hasPrevPage: false,
    hasNextPage: true,
    prevPage: null,
    nextPage: null
  },
  auditStats: null,
  auditLogDetail: null
}
